import { to } from "@lib/utils";
import { NFTCollection, NFTCollectionParam } from "@models/nft";
import { apiClient } from "@providers/auth";

export const getCollectionsByEventId = async (eventId: string) => {
  const { res } = await to(apiClient.get(`/events/${eventId}/collections`));
  if (!res) return [];
  return (res as NFTCollectionParam[]).map(
    (collection) => new NFTCollection(collection)
  );
};
